export const GET_POSITION_TYPES = "GET_POSITION_TYPES";
export const GET_POSITION_TYPES_SUCCESS = "GET_POSITION_TYPES_SUCCESS";
export const GET_POSITION_TYPES_ERROR = "GET_POSITION_TYPES_ERROR";
